import { AppComponent } from '../app/app.component';
import { GraphResourceRegistryDev } from '../app/services/graph-resource-registry.dev';

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  azureRegistration: {
    clientId: 'cdca119f-2192-4708-a643-54077f161904',
    authority: 'https://login.microsoftonline.com/51cb5df4-df05-4e5b-b20c-17d576ab85e3',
    redirectUrl: 'https://campfire.traveledge.com',
    postLogoutRedirectUrl: 'https://campfire.traveledge.com'
  },
  entryComponents: [AppComponent],
  graphResourceRegistryImpl: GraphResourceRegistryDev
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
